var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCircleKigyou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_relation_prof",
    transform: "translate(0.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_32",
    "data-name": "\\u6955\\u5186\\u5F62 32",
    transform: "translate(-0.134)",
    fill: "#fff",
    stroke: "#1c4ec1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_201",
    "data-name": "\\u30D1\\u30B9 201",
    d: "M16.863,16.863h2.409v-2.41H16.863Zm0-4.818h2.409V9.636H16.863ZM2.409,16.863H4.818v2.409H2.409Zm4.818,0H9.636v2.409H7.227ZM2.409,12.045H4.818v2.409H2.409Zm4.818,0H9.636v2.409H7.227ZM2.409,7.227H4.818V9.636H2.409Zm4.818,0H9.636V9.636H7.227Zm4.818,0h9.636V19.273H12.045V16.863h2.409V14.454H12.045V12.045h2.409V9.636H12.045ZM2.409,2.409H4.818V4.818H2.409Zm4.818,0H9.636V4.818H7.227ZM0,0V21.682H24.091V4.818H12.045V0Z",
    transform: "translate(15.821 17.159)",
    fill: "#1c4ec1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCircleKigyou);
export default __webpack_public_path__ + "static/media/ico_circle_kigyou.2e6df3698af312c94d197137ff199831.svg";
export { ForwardRef as ReactComponent };